import { ArrowRight, ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/shared/components/ui/button";
import { shiftIso, toDayMonthYear } from "@/shared/utils/date";

export function WindowNav({
  startIso,
  days,
  onPrev,
  onNext,
  onToday,
}: {
  startIso: string;
  days: number;
  onPrev: () => void;
  onNext: () => void;
  onToday: () => void;
}) {
  const endIso = shiftIso(startIso, days - 1);
  return (
    <div className="flex items-center gap-2">
      <Button
        variant="outline"
        size="sm"
        onClick={onPrev}
        aria-label="Föregående vecka"
      >
        <ChevronLeft />
      </Button>
      <Button variant="outline" size="sm" onClick={onToday}>
        Nuvarande vecka
      </Button>
      <Button
        variant="outline"
        size="sm"
        onClick={onNext}
        aria-label="Nästa vecka"
      >
        <ChevronRight />
      </Button>
      <span className="ml-2 hidden items-center gap-1 text-sm text-muted-foreground md:inline-flex">
        {toDayMonthYear(startIso)}
        <ArrowRight className="size-3.5" aria-hidden />
        {toDayMonthYear(endIso)}
      </span>
    </div>
  );
}
